import React, { Component } from 'react';
import SidebarElement from './SidebarElement'
import Image from '../Images/logoBlack.png'
import { NavLink } from 'react-router-dom'
import './Sidebar.css'
class Sidebar extends Component {
    state = { 
        visible:true,
        elements:[
            {
                title:'Dashboard',
                SVG:<svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round"
                     strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>,
                link:"/dashboard",
                     
            },
            {
                title:'Departments',
                SVG:<svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor"
             viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"></path></svg>,
                link:"/departments",
                
            },
            {
                title:'users',
                SVG:<svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>,
                link:"/users",
                
            },
            {
                title:'Logout',
                SVG:<svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round"
                strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>,
                link:"/logout",
            }
        ]
     }
     toggleMenu(){
         let {visible} = this.state
         this.setState({
             visible :!visible
         })
     }
    render() { 
        let {elements} = this.state
        let ulStyles = "text-sm mt-2"
        ulStyles+= this.state.visible ? " hidden md:block" : ""
        let { user } = this.props
        
        return ( 
                <div className="block md-hidden ">
                   <div className="">
                      <img src={Image} className="w-full hidden md:block h-screen md:w-40 md:h-24" alt=""/>
                      <svg onClick={this.toggleMenu.bind(this)} className="float-right w-6 h-6 block md:hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
                   </div>
                       <nav className="text-left">
                          { user.is_admin ? 
                        <ul className={ulStyles}>
                         {elements.map(element=>
                          <SidebarElement 
                          key={element.title}
                           badge={element.badge}
                           title={element.title}
                           SVG={element.SVG}
                           link={element.link}
                          />
                          )}
                        </ul>
                         : 
                          <ul className={ulStyles}>
                             <li className="font-semibold mt-2">
                                <NavLink to="/dashboard" activeClassName="active" className="flex px-4 mt-4">
                                <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor"
                                    viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                     strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                                    <span  className="text-xs lg:text-sm text-gray-500 ">Dashboard</span>
                                </NavLink>
                            </li>
                             <li className="font-semibold mt-2">
                                <NavLink to="/departments" activeClassName="active" className="flex px-4 mt-4">
                                <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor"
                                   viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                      d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"></path></svg>
                                    <span  className="text-xs lg:text-sm text-gray-500 ">Departments</span>
                                </NavLink>
                            </li>
                             <li className="font-semibold mt-2">
                                <NavLink to="/logout" activeClassName="active" className="flex px-4 mt-0 md:mt-80">
                                <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round"
                                    strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
                                    <span  className="text-xs lg:text-sm text-gray-500 ">Logout</span>
                                </NavLink>
                            </li>
                          </ul>
                        }
                       </nav>
                    
                </div>
         );
    }
}
 
export default Sidebar;